import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { BasicFlex } from '../../Common';

import { Card } from '@mui/material';

import { isEmpty, startCase } from 'lodash';

import { formatCurrency } from '../../util';

const CardStyle = styled.div`
  border: 1px solid ${props => props.theme.colors.border};
  padding: 0.8rem;
  min-width: 20rem;
  background-color: ${props => props.theme.colors.white};
  border-radius: 5px;

  ${props => props.$balance && css/* closed */`
    border-left: 3px solid ${props.$negative ? props.theme.colors.error : props.theme.colors.success};
  `}
`

const Label = styled.div`
  font-weight: 500;
  font-size: 1rem;
  color: ${props => props.theme.colors.mildText};
  text-transform: uppercase;
`

const Total = styled.div`
  font-weight: 600;
  font-size: 1.6rem;
  color: ${props => props.$balance ? props.$negative ? props.theme.colors.error : props.theme.colors.success : ''};
`

const isBalance = (field) => {
  let key = startCase(field);
  if (key.includes('Balance')) return true;
  return false;
}

const isNegativeBalance = (field, value) => {
  let isBal = isBalance(field);
  if (isBal && value > 0) return true;
  return false;
}

const TotalBar = ({ totals }) => {

  if (isEmpty(totals)) return null;

  return (
    <BasicFlex my="1rem" justify="flex-start" gap="1rem">
      {Object.entries(totals).filter(([key, value]) => key !== 'count').map(([key, value]) => (
        <CardStyle key={key} variant="outlined" $balance={isBalance(key)} $negative={isNegativeBalance(key, value)}>
          <BasicFlex dir="column" gap=".5rem">
            <Label>{startCase(key)}</Label> 
            <Total $balance={isBalance(key)} $negative={isNegativeBalance(key, value)}>{formatCurrency(value)}</Total>
          </BasicFlex>
        </CardStyle>
      ))}
    </BasicFlex>
  )
};

export default TotalBar;